import script from "./CPR00100.vue?vue&type=script&setup=true&lang=ts"
export * from "./CPR00100.vue?vue&type=script&setup=true&lang=ts"

import "./CPR00100.vue?vue&type=style&index=0&id=e5fff7f6&scoped=true&lang=css"
import "./CPR00100.vue?vue&type=style&index=1&id=e5fff7f6&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5fff7f6"]])

export default __exports__
import QForm from 'quasar/src/components/form/QForm.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QForm,QCard,QCardSection,QInput,QCardActions,QBtn,QChip});
